import { useQuery } from "@tanstack/react-query";
import { ColumnsType } from "antd/es/table";
import { useState } from "react";
import { AiOutlineEdit } from "react-icons/ai";
import { getMembershipsAdmin } from "../../../network/admin";
import AntTable from "../../AntTable/AntTable";
type Props = {
  isFilter: any;
  selectedRowKeys: any;
  setSelectedRowKeys: any;
  searchHeader: any;
};

const TabMemberships = ({
  isFilter,
  selectedRowKeys,
  setSelectedRowKeys,
  searchHeader,
}: Props) => {
  const getExpiryDurationInDays = (duration: string) => {
    let days = 0;
    switch (duration) {
      case "one_month":
        days = 30;
        break;
      case "three_months":
        days = 90;
        break;
      case "six_months":
        days = 180;
        break;
      case "one_year":
        days = 365;
        break;
    }
    return days;
  };

  const [page, setPage] = useState<number>(1);
  const { data, isLoading } = useQuery(
    ["membership", page, isFilter, searchHeader],
    () => getMembershipsAdmin({ page, ...isFilter, search: searchHeader })
  );

  const columns: ColumnsType<any> = [
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">
          Membership name
        </div>
      ),
      dataIndex: "first_name",
      render: (text: any, record) => (
        <div className="text-sm font-medium text-color-primary">
          {record?.name}
        </div>
      ),
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">
          Associated salon
        </div>
      ),
      dataIndex: "phone",
      // responsive: ["lg"],
      render: (text: any, record) => (
        <div className="text-sm font-medium text-color-primary" dir="ltr">
          {record?.salon?.name}
        </div>
      ),
    },
    {
      title: <div className="text-[#9999A7] text-sm font-normal">Services</div>,
      dataIndex: "display_all_booking",

      render: (text: any, record) => (
        <div className="text-sm font-medium text-color-primary">
          {record?.services_count}
        </div>
      ),
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">Expiry time</div>
      ),
      dataIndex: "totalSales",

      render: (text: any, record) => (
        <div className="text-[#9999A7]">
          <span className="text-sm font-bold text-color-primary">
            {getExpiryDurationInDays(record?.expire_duration)} days
          </span>
        </div>
      ),
    },
    {
      title: <div className="text-[#9999A7] text-sm font-normal">Price</div>,
      dataIndex: "created_at",
      // responsive: ["lg"],
      render: (text: any, record) => (
        <div
          className={`text-sm text-color-primary font-bold flex items-center w-full justify-between`}
        >
          {record?.price} SR
        </div>
      ),
    },
    {
      title: <div></div>,
      dataIndex: "edit",
      // responsive: ["lg"],
      render: (text: any, record) => (
        <div className="w-fit hover:bg-[#EEF0FF] p-2 rounded-full cursor-pointer">
          <AiOutlineEdit className="text-[]" />
        </div>
      ),
    },
  ];
  return (
    <div>
      <AntTable
        tableColumns={columns}
        tableData={data?.data}
        isLoading={isLoading}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        expandRowByClick={false}
        // hideArrowExpand
        selectionType={selectedRowKeys}
        setPage={setPage}
        page={page}
        total={data?.meta?.total}
      />
    </div>
  );
};

export default TabMemberships;
